/**
 * WR Beautiful — Mobile menu accordion, body scroll lock, mega menu hover.
 *
 * This script MUST load with defer AFTER global.js so that Dawn's
 * MenuDrawer / HeaderDrawer classes are already defined.
 *
 * Features:
 *  1. Prevents Dawn's MenuDrawer from interfering with .wr-accordion <details>
 *  2. iOS-safe body scroll lock (position:fixed pattern instead of overflow:hidden)
 *  3. Desktop mega menu hover trigger with 200ms delay ([data-wr-hover-menu])
 */
(function () {
  'use strict';

  /* ────────────────────────────────────────────────────────────
     1. ACCORDION — Intercept Dawn's handlers on .wr-accordion
     Dawn binds click handlers to EVERY <summary> and <button>
     inside <header-drawer>. We use a capture-phase listener on
     the drawer element to call stopImmediatePropagation() for
     clicks on accordion summaries, so native <details> toggle
     works without Dawn trying to slide-in submenus.
     ──────────────────────────────────────────────────────────── */
  var drawerEl = document.querySelector('header-drawer');
  if (drawerEl) {
    drawerEl.addEventListener(
      'click',
      function (event) {
        /* Only intercept direct summary children of .wr-accordion */
        var accordionSummary = event.target.closest('.wr-accordion > summary');
        if (accordionSummary) {
          event.stopImmediatePropagation();
          /* Native <details> toggle still fires (we did NOT preventDefault) */
        }
      },
      true /* capture phase — fires before Dawn's target-phase handlers */
    );
  }

  /* ────────────────────────────────────────────────────────────
     2. iOS-SAFE BODY SCROLL LOCK
     Using position:fixed + top:-scrollY instead of overflow:hidden.
     overflow:hidden is broken on iOS Safari with the address bar.
     ──────────────────────────────────────────────────────────── */
  var savedScrollY = 0;

  function enableScrollLock() {
    savedScrollY = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function disableScrollLock() {
    /* Only restore if we locked it */
    if (document.body.style.position !== 'fixed') return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, savedScrollY);
  }

  var drawerDetails = document.getElementById('Details-menu-drawer-container');
  if (drawerDetails) {
    /*
     * toggle event fires when <details> open attribute changes.
     * – Open:  <details> gains open → enable scroll lock
     * – Close: Dawn removes open after 400ms animation → disable scroll lock
     *
     * We also watch the 'menu-opening' class to detect close START
     * (Dawn removes this class when the close animation begins).
     */
    drawerDetails.addEventListener('toggle', function () {
      if (drawerDetails.open) {
        enableScrollLock();
      }
    });

    /* Detect close animation start — Dawn removes 'menu-opening' class */
    var classObserver = new MutationObserver(function () {
      if (
        !drawerDetails.classList.contains('menu-opening') &&
        drawerDetails.hasAttribute('open')
      ) {
        /* Close animation started — unlock scroll immediately */
        disableScrollLock();
      }
    });
    classObserver.observe(drawerDetails, {
      attributes: true,
      attributeFilter: ['class'],
    });

    /* Fallback — also disable when open attribute is fully removed */
    var openObserver = new MutationObserver(function () {
      if (!drawerDetails.hasAttribute('open')) {
        disableScrollLock();
      }
    });
    openObserver.observe(drawerDetails, {
      attributes: true,
      attributeFilter: ['open'],
    });
  }

  /* ────────────────────────────────────────────────────────────
     3. MEGA MENU HOVER — 200ms enter/leave delay
     Applied to <details data-wr-hover-menu> elements.
     Desktop only (>= 990px). Touch devices use click.
     ──────────────────────────────────────────────────────────── */
  var HOVER_DELAY = 200;
  var hoverMenus = document.querySelectorAll('[data-wr-hover-menu]');

  hoverMenus.forEach(function (details) {
    var parentLi = details.closest('li');
    if (!parentLi) return;

    var enterTimeout = null;
    var leaveTimeout = null;

    parentLi.addEventListener('mouseenter', function () {
      if (window.innerWidth < 990) return;
      clearTimeout(leaveTimeout);
      enterTimeout = setTimeout(function () {
        if (!details.open) {
          details.open = true;
          /* Dawn's onToggle fires automatically via native toggle event */
        }
      }, HOVER_DELAY);
    });

    parentLi.addEventListener('mouseleave', function () {
      if (window.innerWidth < 990) return;
      clearTimeout(enterTimeout);
      leaveTimeout = setTimeout(function () {
        if (details.open) {
          details.open = false;
          var summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      }, HOVER_DELAY);
    });

    /* Keyboard support: close on Escape */
    details.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && details.open) {
        details.open = false;
        var summary = details.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
          summary.focus();
        }
      }
    });
  });

  /* ────────────────────────────────────────────────────────────
     4. CLEANUP — Disable scroll lock on page unload / section reload
     ──────────────────────────────────────────────────────────── */
  window.addEventListener('beforeunload', disableScrollLock);
  document.addEventListener('shopify:section:load', function () {
    disableScrollLock();
  });
})();
